import React, { useState } from "react";
import "./heropage.css";

function Hero() {


    const [data, setData] = useState({ pickupLocation: '', dropLocation: '', timeSchedule: '' })

    const handleOnChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
   
    }

    const handleBookNow = (e) => {
        e.preventDefault();
     if(data?.pickupLocation&&data?.dropLocation&&data?.timeSchedule){
        const whatsappNumber = '8310311913';
        const message = `I'd like to book a vehicle from ${data?.pickupLocation} to ${data?.dropLocation} at ${data?.timeSchedule}.`;

        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

        window.location.href = whatsappURL;
     }else{
        alert("All fields are required!")
     }
    };

    const backgroundImageStyle = {
        backgroundImage: 'url("/img/back-1.jpg")',
        width: '100%',
        height: '90vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: 0,
        margin: 0
      };

    return (
        <div style={backgroundImageStyle} >
            <div className="hero-container">
                <div className="hero-content">
                    <div className="hero-content-1">
                        <h1 className="hero-title">Transparent. Safe. <span>Reliable</span></h1>
                        <p className="hero-description">Experience hassle-free booking, transparent pricing, and personalized travel solutions tailored to your needs. Let Ashlesha Cabs make every trip memorable. Your destination is just a ride away with us!</p>
                    </div>

                    <div className="hero-book-now">
                        <div className="hero-pickup">
                            <img src="/icon/MagnifyingGlass.png" alt="marker" />
                            <input type="text" name="pickupLocation" placeholder="Pickup Location" onChange={handleOnChange} />
                        </div>
                        <div className="hero-drop">
                            <img src="/icon/MapPinLine.png" alt="marker" />
                            <input type="text" placeholder="Drop Location" name="dropLocation" onChange={handleOnChange} />
                        </div>
                        <div className="hero-time">
                            <img src="/icon/Icon.png" alt="marker" />
                            <input type="datetime" placeholder="Time Schedule" name="timeSchedule" onChange={handleOnChange} />
                        </div>
                        <button className="hero-btn" onClick={handleBookNow}>Book Now</button>
                    </div>

                    <div className="book-call">
                        <a href="tel:+91 8310311913" className="book-now-hero">Call Now</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Hero;
